import smoothscroll from 'smoothscroll-polyfill';

const header = document.querySelector('header');

const findCorrectClickTarget = function(element, cls) {
  let el = element;

  while (!el.classList.contains(cls)) {
    el = el.parentElement;
  }

  return el;
};

const clickEvent = function(event) {
  event.preventDefault();
  const trigger = findCorrectClickTarget(event.target, 'js-scroll-to');
  const targetPanel = document.querySelector(trigger.getAttribute('href'));
  const topOfElement = targetPanel.offsetTop;
  const options = {
    top: topOfElement,
    left: 0,
    behavior: 'smooth',
  };

  if (topOfElement < window.pageYOffset) {
    window.setTimeout(() => {
      header.classList.remove('c-header--pinned');
      header.classList.add('c-header--unpinned');
    }, 1500);
  }

  window.scrollTo(options);
};

const scrollTo = function() {
  const scrollElements = document.querySelectorAll('.js-scroll-to');

  if (scrollElements == null) {
    return;
  }

  smoothscroll.polyfill();

  for (let i = scrollElements.length - 1; i >= 0; i -= 1) {
    scrollElements[i].addEventListener('click', clickEvent);
  }
};

export default scrollTo;



// WEBPACK FOOTER //
// ./src/scripts/modules/scroll-to.js